import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { LOCAL_STORAGE_LANGUAGE_KEY, I18NEXT_RU } from './constants';

const language = window?.localStorage?.getItem(LOCAL_STORAGE_LANGUAGE_KEY) ?? I18NEXT_RU;

i18next
  .use(LanguageDetector) // Смотрит язык пользователя в браузере и ставит его в i18next(поле lng в конфигурации)
  .use(initReactI18next) // Модуль для React
  .use(Backend) // Закачиваем файлы переводов отдельно и только те, которые нужны пользователю
  // Все опции конфигурации для функции init: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'ru'],
    lng: language,
    updateMissing: true,
    nsSeparator: false,
    initImmediate: false,
    preload: ['en', 'ru'],
    keySeparator: false,
    debug: false,
    react: {
      useSuspense: true,
    },

    interpolation: {
      escapeValue: false, // Реакт делает это по-умолчанию, поэтому выключаем
    },
  });

export default i18next;
